/* @flow */

import { compose } from 'ramda';
import * as React from 'react';

type Props = {
  className: string,
  field: Object,
  inputProps: Object,
  handleFocus: () => void,
  handleBlur: () => void,
};

const FormikInput = ({
  className,
  field,
  inputProps,
  handleFocus,
  handleBlur,
}: Props): React.Node => (
  <input
    className={className}
    {...field}
    {...inputProps}
    onFocus={handleFocus}
    onBlur={(e) => {
      field.onBlur(e);

      handleBlur();
    }}
  />
);

export default compose(React.memo)(FormikInput);
